
export default function ContactMap() {
  return (
    <section className="py-16 md:py-20 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <span className="inline-block text-amber-500 text-xs font-bold uppercase tracking-widest mb-3">
            Ubicación del estudio
          </span>
          <h2
            className="text-[36px] sm:text-[48px] md:text-[60px] leading-none font-bold text-white mb-4"
            style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '3px' }}
          >
            VISÍTANOS EN ADRA
          </h2>
          <p className="text-neutral-400 text-sm md:text-base max-w-xl mx-auto">
            Nuestro estudio está situado en el corazón de Adra, Almería. Fácil acceso y aparcamiento cercano.
          </p>
        </div>

        <div className="relative rounded-lg overflow-hidden border border-neutral-700/50">
          <div className="w-full h-[400px] md:h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12856.47!2d-3.0206!3d36.7494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd7a9e5c3f1b1b1b%3A0x1234567890abcdef!2sAdra%2C%20Almer%C3%ADa!5e0!3m2!1ses!2ses!4v1700000000000"
              width="100%"
              height="100%"
              style={{ border: 0, filter: 'grayscale(60%) contrast(1.1)' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación Daro Tattoo en Adra, Almería"
            ></iframe>
          </div>

          {/* Floating info card */}
          <div className="absolute bottom-4 left-4 right-4 sm:right-auto sm:max-w-sm bg-neutral-900/90 backdrop-blur-md border border-neutral-700 rounded-lg p-5">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-amber-600 rounded-lg flex-shrink-0 mt-0.5">
                <i className="ri-map-pin-2-fill text-white text-lg"></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-base mb-1" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}>
                  DARO TATTOO STUDIO
                </h3>
                <p className="text-neutral-400 text-sm mb-1">Calle Natalio Rivas, 04770 Adra</p>
                <p className="text-neutral-500 text-xs mb-3">Almería, España</p>
                <div className="flex flex-wrap gap-3">
                  <a
                    href="https://www.google.com/maps/search/Daro+Tattoo+Adra+Almeria"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-amber-600 text-white text-xs font-medium rounded-md hover:bg-amber-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-route-line"></i>
                    Cómo llegar
                  </a>
                  <a
                    href="https://www.google.com/maps/search/Daro+Tattoo+Adra+Almeria"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-neutral-700 text-neutral-300 text-xs font-medium rounded-md hover:bg-neutral-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-fullscreen-line"></i>
                    Ver más grande
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Schedule & details */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-8">
          <div className="bg-neutral-800/50 border border-neutral-700/50 rounded-lg p-5 text-center">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-600/15 rounded-full mx-auto mb-3">
              <i className="ri-time-line text-amber-500 text-lg"></i>
            </div>
            <h4 className="text-white font-bold text-sm mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}>
              HORARIO
            </h4>
            <p className="text-neutral-400 text-sm">Lunes a Viernes: 10:00 - 20:00</p>
            <p className="text-neutral-400 text-sm">Sábado: 10:00 - 14:00</p>
            <p className="text-neutral-500 text-xs mt-1">Domingo: Cerrado</p>
          </div>
          <div className="bg-neutral-800/50 border border-neutral-700/50 rounded-lg p-5 text-center">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-600/15 rounded-full mx-auto mb-3">
              <i className="ri-parking-box-line text-amber-500 text-lg"></i>
            </div>
            <h4 className="text-white font-bold text-sm mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}>
              APARCAMIENTO
            </h4>
            <p className="text-neutral-400 text-sm">Parking gratuito en la zona</p>
            <p className="text-neutral-400 text-sm">Fácil acceso en coche</p>
            <p className="text-neutral-500 text-xs mt-1">A 2 min del centro</p>
          </div>
          <div className="bg-neutral-800/50 border border-neutral-700/50 rounded-lg p-5 text-center">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-600/15 rounded-full mx-auto mb-3">
              <i className="ri-bus-line text-amber-500 text-lg"></i>
            </div>
            <h4 className="text-white font-bold text-sm mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}>
              TRANSPORTE
            </h4>
            <p className="text-neutral-400 text-sm">Parada de bus cercana</p>
            <p className="text-neutral-400 text-sm">Líneas Adra - Almería</p>
            <p className="text-neutral-500 text-xs mt-1">A 5 min caminando</p>
          </div>
        </div>
      </div>
    </section>
  );
}
